import React from 'react';
import Modal from '../Modal/Modal';
import CreateConfigurationForm from '../Modal/CreateConfigurationForm';
import { P3Configuration } from 'models/interfaces/P3Configurations';
import { printDate, iso8601 } from 'util/dateUtils';
import moment from 'moment';

interface P3TemplateEditProps {
  isModalOpen: boolean;
  companyName: string;
  formTitle: string;
  template: P3Configuration;
  onClose: () => void;
  onSaveConfig: (values: any) => void;
}

const P3TemplateEdit: React.FC<P3TemplateEditProps> = ({
  isModalOpen,
  companyName,
  formTitle,
  template,
  onClose,
  onSaveConfig
}) => {
  console.log('template to edit: ', template);

  let startDate: string;
  let endDate: string;

  if (template.start_date && template.end_date) {
    startDate = printDate(template.start_date);
    endDate = printDate(template.end_date);
  } else {
    // calculate default start dates
    const defaultStartDate = moment()
      .day(0)
      .add(1, 'month');

    const defaultEndDate = moment(defaultStartDate).add(1, 'year');

    // set startDate & endDate
    startDate = defaultStartDate.format('MM/DD/YYYY');
    endDate = defaultEndDate.format('MM/DD/YYYY');
  }

  const nameValidation = (value: string) => {
    if (!value) {
      return 'Required';
    }

    return null;
  };

  const validateEndDate = (value: string, values: any) => {
    const ed = new Date(value);
    const sd = new Date(values.startDate);

    if (!value) {
      return 'Campaign End Date is required';
    }

    if (ed && sd > ed) {
      return 'Campaign End Date must be after Campaign Start Date';
    }

    return null;
  };

  const validateStartDate = (value: string, values: any) => {
    const sd = new Date(value);
    const ed = new Date(values.endDate);

    if (!value) {
      return 'Campaign Start Date is required';
    }

    if (ed && sd > ed) {
      return 'Campaign Start Date must be before Campaign End Date';
    }

    return null;
  };

  const composeSaveObject = (values: any) => {
    const saveObject: P3Configuration = {
      // existing data
      p3_configuration_id: template.p3_configuration_id,
      p3_campaign_id: template.p3_campaign_id,
      configuration_status_id: template.configuration_status_id,
      tgrams_id: template.tgrams_id,
      rank_points: template.rank_points,
      coverage_areas: template.coverage_areas,
      preview_ads: template.preview_ads,
      program_value: template.p3_configuration_id,
      // data from form
      name: values.name,
      description: values.description,
      start_date: iso8601(values.startDate),
      end_date: iso8601(values.endDate),
      regions: template.regions,
      categories: template.categories
    };

    onSaveConfig(saveObject);
  };
  const description = template&& template.description? template.description: '';

  const initialValues = {
    name: template ? template.name : '',
    startDate: new Date(startDate),
    endDate: new Date(endDate),
    description: description
  };

  return (
    <Modal
      onClose={onClose}
      isModalOpen={isModalOpen}
      el={document.createElement('div')}
      modalWidth="80%"
    >
      <CreateConfigurationForm
        onFormSubmit={composeSaveObject}
        nameValidation={nameValidation}
        validateStartDate={validateStartDate}
        validateEndDate={validateEndDate}
        initialValues={initialValues}
        formName={companyName ? `${companyName} - ${formTitle}` : `${formTitle}`}
      />
    </Modal>
  );
};

export default P3TemplateEdit;
